export const endpoints = {
    getAllTips: '/tipsDash/API/getTipsForBuilding/:buildingId',
    getTipsLog: '/API/tipLogs/:tipId',
    updateTipStatus: '/API/updateTipStatus/:tipId',

    // nSide ASSESS
    // student
    findStudentBySsid: '/find_student_by_student_identifier/region/:regionId', // find student by ssid
    createStudent: '/create_student_record/region/:regionId', // create student & create new case for that student
    updateStudent: '/update_student/region/:regionId', // update student
    // case
    createNewCaseForExistingStudent: '/create_assess_case', // create new case for existing student
    getAllAssessCasesByStudentID: '/find_assess_cases_by_student_identifier', // get all cases of a student (POST)
    findTipsAssessRel: '/tipsDash/API/findTipsAssessRel'// find assess case and tip relationship by tip id
};
  